import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dog_insurance_cancelled = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('cancelled_by_previous_insurer')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_insurance_cancelled.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('cancelled_by_previous_insurer'),
      },
    ],
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('cancelled_by_previous_insurer'),
      valueToStepName: {
        true: 'failure',
        false: 'dog_sos_help',
      },
    },
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default dog_insurance_cancelled
